module.exports = __webpack_public_path__ + "static/awareness_employees-b1e457b34e68a2c330f90a2faa8e3ce8.png";